const PRODUCT_METAFIELDS_TUNE = `#graphql
  fragment ProductMetafieldsTune on Product {
    sizeChart: metafield(namespace: "size", key: "chart") {
      ...MetafieldFields
    }
    productCategory: metafield(namespace: "category", key: "sub") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "notice", key: "content") {
      ...MetafieldFields
    }
    dropDate: metafield(namespace: "operation", key: "drop_date") {
      ...MetafieldFields
    }
    isOffline: metafield(namespace: "custom", key: "isoffline") {
      ...MetafieldFields
    }
    instagram: metafield(namespace: "custom", key: "instagram") {
      ...MetafieldFields
    }
    additionalDescription: metafield(namespace: "additional", key: "description") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "custom", key: "quantity_limit") {
      ...MetafieldFields
    }
    launch: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
      }
    }
    seoungsu_stock: metafield(namespace: "info", key: "seongsu_stock") {
      ...MetafieldFields
    }
    hidden: metafield(namespace: "custom", key: "hidden") {
      ...MetafieldFields
    }
    preorder: metafield(namespace: "operation", key: "preorder") {
      ...MetafieldFields
      reference {
        ...MetaobjectKeyValueFields
      }
    }
    accessible_memberships: metafield(namespace: "custom", key: "accessible_memberships") {
      ...MetafieldFields
    }
    color: metafield(namespace: "filter", key: "color") {
      ...MetafieldFields
    }
    membershipAutoDiscount: metafield(namespace: "operation", key: "membership_auto_discount") {
      ...MetafieldFields
    }
    offlineOnlyMessage: metafield(namespace: "info", key: "offline_only_message") {
      ...MetafieldFields
    }
  }
`;

const PRODUCT_METAFIELDS_YESEYESEE = `#graphql
  fragment ProductMetafieldsYeseyesee on Product {
    sizeChart: metafield(namespace: "info", key: "size_chart") {
      ...MetafieldFields
    }
    tag: metafield(namespace: "info", key: "tag") {
      ...MetafieldFields
    }
    additionalDescription: metafield(namespace: "info", key: "additional_description") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "info", key: "notice") {
      ...MetafieldFields
    }
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    hidden: metafield(namespace: "custom", key: "hidden") {
      ...MetafieldFields
    }
    release_date: metafield(namespace: "operation", key: "release_date") {
      ...MetafieldFields
    }
    hoverImage: metafield(namespace: "operation", key: "hover_image") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
    }
  }
`;

const PRODUCT_METAFIELDS_THISISNEVERTHAT = `#graphql
  fragment ProductMetafieldsThisisneverthat on Product {
    notice: metafield(namespace: "notice", key: "content") {
      ...MetafieldFields
    }
    size_fit: metafield(namespace: "size-fit", key: "values") {
      ...MetafieldFields
    }
    hidden: metafield(namespace: "operation", key: "hidden") {
      ...MetafieldFields
    }
    related_collection: metafield(namespace: "operation", key: "related_collection") {
      references(first: 10) {
        edges {
          node {
            ...CollectionSummaryFields
          }
        }
      }
    }
    maleModel: metafield(namespace: "model", key: "info") {
      ...MetafieldFields
    }
    femaleModel: metafield(namespace: "model", key: "info2") {
      ...MetafieldFields
    }
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    availableCountries: metafield(namespace: "operation", key: "available_countries") {
      ...MetafieldFields
    }
    unavailableCountries: metafield(namespace: "operation", key: "unavailable_countries") {
      ...MetafieldFields
    }
    release_date: metafield(namespace: "operation", key: "release_date") {
      ...MetafieldFields
    }
    employeeOnly: metafield(namespace: "operation", key: "employee_only") {
      ...MetafieldFields
    }
  }
`;

const PRODUCT_METAFIELDS_KHAKIS = `#graphql
  fragment ProductMetafieldsKhakis on Product {
    sizeChart: metafield(namespace: "size", key: "chart") {
      ...MetafieldFields
    }
    recommended_style: metafield(namespace: "info", key: "recommended_style") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
        ...MetaobjectProductRefFieldsKhakis
      }
    }
    model: metafield(namespace: "model", key: "size") {
      ...MetafieldFields
    }
    related_collection: metafield(namespace: "operation", key: "related_collection") {
      references(first: 10) {
        edges {
          node {
            ...CollectionSummaryFields
          }
        }
      }
    }
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    hidden: metafield(namespace: "operation", key: "hidden") {
      ...MetafieldFields
    }
    tag: metafield(namespace: "info", key: "tag") {
      ...MetafieldFields
    }
    warning: metafield(namespace: "warning", key: "content") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "notice", key: "content") {
      ...MetafieldFields
    }
    information: metafield(namespace: "info", key: "information") {
      ...MetafieldFields
    }
    unavailableCountries: metafield(namespace: "operation", key: "unavailable_countries") {
      ...MetafieldFields
    }
    launches: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectKeyValueFields
      }
    }
    discountCodeAvailability: metafield(namespace: "operation", key: "discount_code_availability") {
      ...MetafieldFields
    }
    membershipAutoDiscount: metafield(namespace: "operation", key: "membership_auto_discount") {
      ...MetafieldFields
    }
  }
`;

/** khakis recommended_style이 참조하는 Metaobject → Product 목록 (기존 metaObjectProductFragment) */
const METAOBJECT_PRODUCT_REF_FIELDS_KHAKIS = `#graphql
  fragment MetaobjectProductRefFieldsKhakis on Metaobject {
    id
    fields {
      key
      value
      references(first: 120) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              brandName: metafield(namespace: "info", key: "brand_name") {
                ...MetafieldFields
              }
              hidden: metafield(namespace: "operation", key: "hidden") {
                ...MetafieldFields
              }
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductRefFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const PRODUCT_METAFIELDS_SUNLOVE = `#graphql
  fragment ProductMetafieldsSunlove on Product {
    sizeChart: metafield(namespace: "info", key: "size_chart") {
      ...MetafieldFields
    }
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    feature: metafield(namespace: "info", key: "feature") {
      ...MetafieldFields
    }
    materials: metafield(namespace: "info", key: "materials") {
      ...MetafieldFields
    }
    tag: metafield(namespace: "info", key: "tag") {
      ...MetafieldFields
    }
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductCommonFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    dominantColor: metafield(namespace: "operation", key: "dominant_color") {
      ...MetafieldFields
    }
    hidden: metafield(namespace: "operation", key: "hidden") {
      ...MetafieldFields
    }
    hoverImage: metafield(namespace: "operation", key: "hover_image") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
    }
    modelInformation: metafield(namespace: "operation", key: "model_information") {
      ...MetafieldFields
    }
    release_date: metafield(namespace: "operation", key: "release_date") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "info", key: "notice") {
      ...MetafieldFields
    }
  }
`;

const PRODUCT_METAFIELDS_WELLBEINGEXPRESS = `#graphql
  fragment ProductMetafieldsWellbeingexpress on Product {
    notice: metafield(namespace: "info", key: "notice") {
      ...MetafieldFields
    }
    sizeChart: metafield(namespace: "info", key: "size_chart") {
      ...MetafieldFields
    }
    modelInformation: metafield(namespace: "model", key: "info") {
      ...MetafieldFields
    }
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    tag: metafield(namespace: "info", key: "tag") {
      ...MetafieldFields
    }
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsWellbeingexpress
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference {
                  ...MediaImageFields
                }
                references(first: 10) {
                  edges {
                    node {
                      ...MediaImageFields
                    }
                  }
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductFieldsWellbeingexpress
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    styleWithProducts: metafield(namespace: "operation", key: "style_with_products") {
      ...MetafieldFields
      references(first: 10) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsWellbeingexpress
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference {
                  ...MediaImageFields
                }
                references(first: 10) {
                  edges {
                    node {
                      ...MediaImageFields
                    }
                  }
                }
              }
              variants(first: 10) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductFieldsWellbeingexpress
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    hidden: metafield(namespace: "operation", key: "hidden") {
      ...MetafieldFields
    }
    materials: metafield(namespace: "info", key: "materials") {
      ...MetafieldFields
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
  }
`;

/** 메뉴/관련컬렉션 등에서 쓰는 컬렉션 요약 (기존 collectionFragment) */
const COLLECTION_SUMMARY_FIELDS = `#graphql
  fragment CollectionSummaryFields on Collection {
    __typename
    handle
    title
    id
    tag: metafield(namespace: "operation", key: "tag") {
      ...MetafieldFields
    }
  }
`;

/* ------------------------------------------------------------------ *
 * variant metafield (variantMetafields)
 *  - khakis만 성수/연희 재고 metafield를 조회한다
 * ------------------------------------------------------------------ */

const VARIANT_METAFIELDS_KHAKIS = `#graphql
  fragment VariantMetafieldsKhakis on ProductVariant {
    seongsuStock: metafield(namespace: "custom", key: "seongsu_stock") {
      ...MetafieldFields
    }
    yeonhuiStock: metafield(namespace: "custom", key: "yeonhui_stock") {
      ...MetafieldFields
    }
  }
`;

/** variants(first: n) 안에서 공통으로 붙는 metafield (restock / brandVariantId) */
const VARIANT_COMMON_METAFIELDS = `#graphql
  fragment VariantCommonMetafields on ProductVariant {
    restock: metafield(namespace: "operation", key: "restock_notification") {
      ...MetafieldFields
    }
    brandVariantId: metafield(namespace: "familysale", key: "brand_variant_id") {
      ...MetafieldFields
    }
  }
`;

/* ------------------------------------------------------------------ *
 * 컬렉션 문서에서 쓰는 상품 필드 조합
 *  - CommonProductFields{Store}           : 컬렉션 상세(handle) 목록용
 *  - CommonCollectionProductFields{Store} : 퀵애드 목록용
 *  기존 collectionListingProductMetafields는 productMetafields에 이미 모두 포함돼 별도 정의하지 않는다.
 * ------------------------------------------------------------------ */

const COMMON_PRODUCT_FIELDS_TUNE = `#graphql
  fragment CommonProductFieldsTune on Product {
    ...ProductFieldsTune
    ...ProductMetafieldsTune
    collections(first: 20) {
      edges {
        node {
          title
          handle
          description
        }
      }
    }
    variants(first: 60) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductFieldsTune
          }
        }
      }
    }
  }
`;

const COMMON_COLLECTION_PRODUCT_FIELDS_TUNE = `#graphql
  fragment CommonCollectionProductFieldsTune on Product {
    ...ProductFieldsTune
    ...ProductMetafieldsTune
    variants(first: 100) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductFieldsTune
          }
        }
      }
    }
  }
`;

const COMMON_PRODUCT_FIELDS_YESEYESEE = `#graphql
  fragment CommonProductFieldsYeseyesee on Product {
    ...ProductCommonFields
    ...ProductMetafieldsYeseyesee
    collections(first: 20) {
      edges {
        node {
          title
          handle
          description
        }
      }
    }
    variants(first: 60) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const COMMON_COLLECTION_PRODUCT_FIELDS_YESEYESEE = `#graphql
  fragment CommonCollectionProductFieldsYeseyesee on Product {
    ...ProductCommonFields
    ...ProductMetafieldsYeseyesee
    variants(first: 100) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const COMMON_PRODUCT_FIELDS_THISISNEVERTHAT = `#graphql
  fragment CommonProductFieldsThisisneverthat on Product {
    ...ProductCommonFields
    ...ProductMetafieldsThisisneverthat
    collections(first: 20) {
      edges {
        node {
          title
          handle
          description
        }
      }
    }
    variants(first: 60) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const COMMON_COLLECTION_PRODUCT_FIELDS_THISISNEVERTHAT = `#graphql
  fragment CommonCollectionProductFieldsThisisneverthat on Product {
    ...ProductCommonFields
    ...ProductMetafieldsThisisneverthat
    variants(first: 100) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const COMMON_PRODUCT_FIELDS_KHAKIS = `#graphql
  fragment CommonProductFieldsKhakis on Product {
    ...ProductCommonFields
    ...ProductMetafieldsKhakis
    collections(first: 20) {
      edges {
        node {
          title
          handle
          description
        }
      }
    }
    variants(first: 60) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          ...VariantMetafieldsKhakis
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const COMMON_COLLECTION_PRODUCT_FIELDS_KHAKIS = `#graphql
  fragment CommonCollectionProductFieldsKhakis on Product {
    ...ProductCommonFields
    ...ProductMetafieldsKhakis
    variants(first: 100) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          ...VariantMetafieldsKhakis
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const COMMON_PRODUCT_FIELDS_SUNLOVE = `#graphql
  fragment CommonProductFieldsSunlove on Product {
    ...ProductCommonFields
    ...ProductMetafieldsSunlove
    collections(first: 20) {
      edges {
        node {
          title
          handle
          description
        }
      }
    }
    variants(first: 60) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const COMMON_COLLECTION_PRODUCT_FIELDS_SUNLOVE = `#graphql
  fragment CommonCollectionProductFieldsSunlove on Product {
    ...ProductCommonFields
    ...ProductMetafieldsSunlove
    variants(first: 100) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const COMMON_PRODUCT_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment CommonProductFieldsWellbeingexpress on Product {
    ...ProductFieldsWellbeingexpress
    ...ProductMetafieldsWellbeingexpress
    collections(first: 20) {
      edges {
        node {
          title
          handle
          description
        }
      }
    }
    variants(first: 60) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductFieldsWellbeingexpress
          }
        }
      }
    }
  }
`;

const COMMON_COLLECTION_PRODUCT_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment CommonCollectionProductFieldsWellbeingexpress on Product {
    ...ProductFieldsWellbeingexpress
    ...ProductMetafieldsWellbeingexpress
    variants(first: 100) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductFieldsWellbeingexpress
          }
        }
      }
    }
  }
`;

const COLLECTION_DETAIL_PRODUCT_FIELDS_TUNE = `#graphql
  fragment CollectionDetailProductFieldsTune on Product {
    ...ProductFieldsTune
    launch: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
      }
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsTune
              dropDate: metafield(namespace: "operation", key: "drop_date") {
                ...MetafieldFields
              }
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductFieldsTune
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    dropDate: metafield(namespace: "operation", key: "drop_date") {
      ...MetafieldFields
    }
  }
`;

const COLLECTION_DETAIL_PRODUCT_FIELDS_YESEYESEE = `#graphql
  fragment CollectionDetailProductFieldsYeseyesee on Product {
    ...ProductCommonFields
    launch: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
      }
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    relatedProducts: metafield(namespace: "related-product", key: "list") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductCommonFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    dropDate: metafield(namespace: "operation", key: "drop_date") {
      ...MetafieldFields
    }
  }
`;

const COLLECTION_DETAIL_PRODUCT_FIELDS_THISISNEVERTHAT = `#graphql
  fragment CollectionDetailProductFieldsThisisneverthat on Product {
    ...ProductCommonFields
    launch: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
      }
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    relatedProducts: metafield(namespace: "related-product", key: "list") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductCommonFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    dropDate: metafield(namespace: "operation", key: "drop_date") {
      ...MetafieldFields
    }
  }
`;

const COLLECTION_DETAIL_PRODUCT_FIELDS_KHAKIS = `#graphql
  fragment CollectionDetailProductFieldsKhakis on Product {
    ...ProductCommonFields
    launch: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
      }
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    relatedProducts: metafield(namespace: "related-product", key: "list") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductCommonFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    dropDate: metafield(namespace: "operation", key: "drop_date") {
      ...MetafieldFields
    }
  }
`;

const COLLECTION_DETAIL_PRODUCT_FIELDS_SUNLOVE = `#graphql
  fragment CollectionDetailProductFieldsSunlove on Product {
    ...ProductCommonFields
    launch: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
      }
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductCommonFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    dropDate: metafield(namespace: "operation", key: "drop_date") {
      ...MetafieldFields
    }
  }
`;

const COLLECTION_DETAIL_PRODUCT_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment CollectionDetailProductFieldsWellbeingexpress on Product {
    ...ProductFieldsWellbeingexpress
    launch: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
      }
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsWellbeingexpress
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference {
                  ...MediaImageFields
                }
                references(first: 10) {
                  edges {
                    node {
                      ...MediaImageFields
                    }
                  }
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductFieldsWellbeingexpress
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    dropDate: metafield(namespace: "operation", key: "drop_date") {
      ...MetafieldFields
    }
  }
`;

const PRODUCT_DETAIL_FIELDS_TUNE = `#graphql
  fragment ProductDetailFieldsTune on Product {
    __typename
    ...CommonProductFieldsTune
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
    media(first: 50) {
      edges {
        node {
          alt
          id
          mediaContentType
          ...MediaImageFields
          ...VideoImageFields
        }
      }
    }
  }
`;

const PRODUCT_RECOMMEND_FIELDS_TUNE = `#graphql
  fragment ProductRecommendFieldsTune on Product {
    ...CommonProductFieldsTune
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
  }
`;

const PRODUCT_DETAIL_FIELDS_YESEYESEE = `#graphql
  fragment ProductDetailFieldsYeseyesee on Product {
    ...CommonProductFieldsYeseyesee
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
    media(first: 50) {
      edges {
        node {
          alt
          id
          mediaContentType
          ...MediaImageFields
          ...VideoImageFields
        }
      }
    }
  }
`;

const PRODUCT_RECOMMEND_FIELDS_YESEYESEE = `#graphql
  fragment ProductRecommendFieldsYeseyesee on Product {
    ...CommonProductFieldsYeseyesee
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
  }
`;

const PRODUCT_DETAIL_FIELDS_THISISNEVERTHAT = `#graphql
  fragment ProductDetailFieldsThisisneverthat on Product {
    ...CommonProductFieldsThisisneverthat
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
    media(first: 50) {
      edges {
        node {
          alt
          id
          mediaContentType
          ...MediaImageFields
          ...VideoImageFields
        }
      }
    }
  }
`;

const PRODUCT_RECOMMEND_FIELDS_THISISNEVERTHAT = `#graphql
  fragment ProductRecommendFieldsThisisneverthat on Product {
    ...CommonProductFieldsThisisneverthat
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
  }
`;

const PRODUCT_DETAIL_FIELDS_KHAKIS = `#graphql
  fragment ProductDetailFieldsKhakis on Product {
    ...CommonProductFieldsKhakis
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
    media(first: 50) {
      edges {
        node {
          alt
          id
          mediaContentType
          ...MediaImageFields
          ...VideoImageFields
        }
      }
    }
  }
`;

const PRODUCT_RECOMMEND_FIELDS_KHAKIS = `#graphql
  fragment ProductRecommendFieldsKhakis on Product {
    ...CommonProductFieldsKhakis
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
  }
`;

const PRODUCT_DETAIL_FIELDS_SUNLOVE = `#graphql
  fragment ProductDetailFieldsSunlove on Product {
    ...CommonProductFieldsSunlove
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
    media(first: 50) {
      edges {
        node {
          alt
          id
          mediaContentType
          ...MediaImageFields
          ...VideoImageFields
        }
      }
    }
  }
`;

const PRODUCT_RECOMMEND_FIELDS_SUNLOVE = `#graphql
  fragment ProductRecommendFieldsSunlove on Product {
    ...CommonProductFieldsSunlove
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
  }
`;

const PRODUCT_DETAIL_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment ProductDetailFieldsWellbeingexpress on Product {
    ...CommonProductFieldsWellbeingexpress
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
    media(first: 50) {
      edges {
        node {
          alt
          id
          mediaContentType
          ...MediaImageFields
          ...VideoImageFields
        }
      }
    }
  }
`;

const PRODUCT_RECOMMEND_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment ProductRecommendFieldsWellbeingexpress on Product {
    ...CommonProductFieldsWellbeingexpress
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
  }
`;

const PREDICTIVE_SEARCH_PRODUCT_FIELDS_TUNE = `#graphql
  fragment PredictiveSearchProductFieldsTune on Product {
    ...ProductFieldsTune
    hidden: metafield(namespace: "custom", key: "hidden") {
      ...MetafieldFields
    }
    launch: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectImageFields
      }
    }
    accessible_memberships: metafield(namespace: "custom", key: "accessible_memberships") {
      ...MetafieldFields
    }
    dropDate: metafield(namespace: "operation", key: "drop_date") {
      ...MetafieldFields
    }
    variants(first: 40) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductFieldsTune
          }
        }
      }
    }
  }
`;

const PREDICTIVE_SEARCH_PRODUCT_FIELDS_YESEYESEE = `#graphql
  fragment PredictiveSearchProductFieldsYeseyesee on Product {
    ...ProductCommonFields
    hidden: metafield(namespace: "custom", key: "hidden") {
      ...MetafieldFields
    }
    variants(first: 40) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const PREDICTIVE_SEARCH_PRODUCT_FIELDS_THISISNEVERTHAT = `#graphql
  fragment PredictiveSearchProductFieldsThisisneverthat on Product {
    ...ProductCommonFields
    hidden: metafield(namespace: "operation", key: "hidden") {
      ...MetafieldFields
    }
    variants(first: 40) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const PREDICTIVE_SEARCH_PRODUCT_FIELDS_KHAKIS = `#graphql
  fragment PredictiveSearchProductFieldsKhakis on Product {
    ...ProductCommonFields
    hidden: metafield(namespace: "operation", key: "hidden") {
      ...MetafieldFields
    }
    launches: metafield(namespace: "custom", key: "launch") {
      ...MetafieldFields
      reference {
        ...MetaobjectKeyValueFields
      }
    }
    variants(first: 40) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          ...VariantMetafieldsKhakis
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const PREDICTIVE_SEARCH_PRODUCT_FIELDS_SUNLOVE = `#graphql
  fragment PredictiveSearchProductFieldsSunlove on Product {
    ...ProductCommonFields
    hidden: metafield(namespace: "operation", key: "hidden") {
      ...MetafieldFields
    }
    variants(first: 40) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductCommonFields
          }
        }
      }
    }
  }
`;

const PREDICTIVE_SEARCH_PRODUCT_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment PredictiveSearchProductFieldsWellbeingexpress on Product {
    ...ProductFieldsWellbeingexpress
    hidden: metafield(namespace: "operation", key: "hidden") {
      ...MetafieldFields
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    variants(first: 40) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductFieldsWellbeingexpress
          }
        }
      }
    }
  }
`;

const METAOBJECT_PRODUCT_REF_FIELDS_TUNE = `#graphql
  fragment MetaobjectProductRefFieldsTune on Metaobject {
    id
    fields {
      key
      value
      references(first: 120) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsTune
              brandName: metafield(namespace: "info", key: "brand_name") { ...MetafieldFields }
              hidden: metafield(namespace: "custom", key: "hidden") { ...MetafieldFields }
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { ...ProductFieldsTune }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const METAOBJECT_PRODUCT_REF_FIELDS_YESEYESEE = `#graphql
  fragment MetaobjectProductRefFieldsYeseyesee on Metaobject {
    id
    fields {
      key
      value
      references(first: 120) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              brandName: metafield(namespace: "info", key: "brand_name") { ...MetafieldFields }
              hidden: metafield(namespace: "custom", key: "hidden") { ...MetafieldFields }
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { ...ProductCommonFields }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const METAOBJECT_PRODUCT_REF_FIELDS_THISISNEVERTHAT = `#graphql
  fragment MetaobjectProductRefFieldsThisisneverthat on Metaobject {
    id
    fields {
      key
      value
      references(first: 120) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              brandName: metafield(namespace: "info", key: "brand_name") { ...MetafieldFields }
              hidden: metafield(namespace: "operation", key: "hidden") { ...MetafieldFields }
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { ...ProductCommonFields }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const METAOBJECT_PRODUCT_REF_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment MetaobjectProductRefFieldsWellbeingexpress on Metaobject {
    id
    fields {
      key
      value
      references(first: 120) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsWellbeingexpress
              brandName: metafield(namespace: "info", key: "brand_name") { ...MetafieldFields }
              hidden: metafield(namespace: "operation", key: "hidden") { ...MetafieldFields }
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { ...ProductFieldsWellbeingexpress }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/** 컬렉션 상세 헤더 (제목/설명/대표 이미지 + 상품 존재 여부 확인용 pages) */
const COLLECTION_DETAIL_BASE_FIELDS = `#graphql
  fragment CollectionDetailBaseFields on Collection {
    __typename
    id
    title
    description
    pages: products(first: 1) { edges { node { id } } }
    handle
    image { ...ImageFields }
  }
`;

/** 이 파일의 모든 fragment (registry 등록용) */
/* ------------------------------------------------------------------ *
 * tenui
 *  - hydrogen(tenui) 시절 실제로 쓰던 메타필드만 옮겼다.
 *    info.capacity / info.card_tag / info.card_description /
 *    info.hover_image / info.subcategory / info.related_products
 * ------------------------------------------------------------------ */

const PRODUCT_METAFIELDS_TENUI = `#graphql
  fragment ProductMetafieldsTenui on Product {
    capacity: metafield(namespace: "info", key: "capacity") {
      ...MetafieldFields
    }
    cardTag: metafield(namespace: "info", key: "card_tag") {
      ...MetafieldFields
    }
    cardDescription: metafield(namespace: "info", key: "card_description") {
      ...MetafieldFields
    }
    subcategory: metafield(namespace: "info", key: "subcategory") {
      ...MetafieldFields
    }
    ingredients: metafield(namespace: "info", key: "ingredients") {
      ...MetafieldFields
    }
    howToUse: metafield(namespace: "info", key: "how_to_use") {
      ...MetafieldFields
    }
    productInfo: metafield(namespace: "info", key: "product_info") {
      ...MetafieldFields
    }
    hoverImage: metafield(namespace: "info", key: "hover_image") {
      ...MetafieldFields
      reference {
        __typename
        ...MediaImageFields
      }
    }
    relatedProducts: metafield(namespace: "info", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              capacity: metafield(namespace: "info", key: "capacity") { ...MetafieldFields }
              cardTag: metafield(namespace: "info", key: "card_tag") { ...MetafieldFields }
              cardDescription: metafield(namespace: "info", key: "card_description") { ...MetafieldFields }
              subcategory: metafield(namespace: "info", key: "subcategory") { ...MetafieldFields }
              hoverImage: metafield(namespace: "info", key: "hover_image") {
                ...MetafieldFields
                reference { ...MediaImageFields }
              }
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductRefFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const COMMON_PRODUCT_FIELDS_TENUI = `#graphql
  fragment CommonProductFieldsTenui on Product {
    ...ProductCommonFields
    ...ProductMetafieldsTenui
    collections(first: 20) {
      edges {
        node {
          title
          handle
          description
        }
      }
    }
    variants(first: 60) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductRefFields
          }
        }
      }
    }
  }
`;

const COMMON_COLLECTION_PRODUCT_FIELDS_TENUI = `#graphql
  fragment CommonCollectionProductFieldsTenui on Product {
    ...ProductCommonFields
    ...ProductMetafieldsTenui
    variants(first: 100) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductRefFields
          }
        }
      }
    }
  }
`;

const COLLECTION_DETAIL_PRODUCT_FIELDS_TENUI = `#graphql
  fragment CollectionDetailProductFieldsTenui on Product {
    ...ProductCommonFields
    capacity: metafield(namespace: "info", key: "capacity") { ...MetafieldFields }
    cardTag: metafield(namespace: "info", key: "card_tag") { ...MetafieldFields }
    cardDescription: metafield(namespace: "info", key: "card_description") { ...MetafieldFields }
    hoverImage: metafield(namespace: "info", key: "hover_image") {
      ...MetafieldFields
      reference { ...MediaImageFields }
    }
    variants(first: 100) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductRefFields
          }
        }
      }
    }
  }
`;

const PRODUCT_DETAIL_FIELDS_TENUI = `#graphql
  fragment ProductDetailFieldsTenui on Product {
    ...CommonProductFieldsTenui
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
    media(first: 50) {
      edges {
        node {
          alt
          id
          mediaContentType
          ...MediaImageFields
          ...VideoImageFields
        }
      }
    }
  }
`;

const PRODUCT_RECOMMEND_FIELDS_TENUI = `#graphql
  fragment ProductRecommendFieldsTenui on Product {
    ...CommonProductFieldsTenui
    images(first: 50) {
      edges {
        node {
          ...ImageFields
        }
      }
    }
  }
`;

const PREDICTIVE_SEARCH_PRODUCT_FIELDS_TENUI = `#graphql
  fragment PredictiveSearchProductFieldsTenui on Product {
    ...ProductCommonFields
    capacity: metafield(namespace: "info", key: "capacity") { ...MetafieldFields }
    cardTag: metafield(namespace: "info", key: "card_tag") { ...MetafieldFields }
    cardDescription: metafield(namespace: "info", key: "card_description") { ...MetafieldFields }
    hoverImage: metafield(namespace: "info", key: "hover_image") {
      ...MetafieldFields
      reference { ...MediaImageFields }
    }
    variants(first: 40) {
      edges {
        node {
          ...VariantBaseFields
          ...VariantCommonMetafields
          product {
            ...ProductRefFields
          }
        }
      }
    }
  }
`;

const METAOBJECT_PRODUCT_REF_FIELDS_TENUI = `#graphql
  fragment MetaobjectProductRefFieldsTenui on Metaobject {
    id
    fields {
      key
      value
      references(first: 120) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              cardTag: metafield(namespace: "info", key: "card_tag") { ...MetafieldFields }
              hoverImage: metafield(namespace: "info", key: "hover_image") {
                ...MetafieldFields
                reference { ...MediaImageFields }
              }
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { ...ProductRefFields }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const PRODUCT_FRAGMENTS = [
  PRODUCT_METAFIELDS_TUNE,
  PRODUCT_METAFIELDS_YESEYESEE,
  PRODUCT_METAFIELDS_THISISNEVERTHAT,
  PRODUCT_METAFIELDS_KHAKIS,
  METAOBJECT_PRODUCT_REF_FIELDS_KHAKIS,
  PRODUCT_METAFIELDS_SUNLOVE,
  PRODUCT_METAFIELDS_WELLBEINGEXPRESS,
  COLLECTION_SUMMARY_FIELDS,
  VARIANT_METAFIELDS_KHAKIS,
  VARIANT_COMMON_METAFIELDS,
  COMMON_PRODUCT_FIELDS_TUNE,
  COMMON_COLLECTION_PRODUCT_FIELDS_TUNE,
  COMMON_PRODUCT_FIELDS_YESEYESEE,
  COMMON_COLLECTION_PRODUCT_FIELDS_YESEYESEE,
  COMMON_PRODUCT_FIELDS_THISISNEVERTHAT,
  COMMON_COLLECTION_PRODUCT_FIELDS_THISISNEVERTHAT,
  COMMON_PRODUCT_FIELDS_KHAKIS,
  COMMON_COLLECTION_PRODUCT_FIELDS_KHAKIS,
  COMMON_PRODUCT_FIELDS_SUNLOVE,
  COMMON_COLLECTION_PRODUCT_FIELDS_SUNLOVE,
  COMMON_PRODUCT_FIELDS_WELLBEINGEXPRESS,
  COMMON_COLLECTION_PRODUCT_FIELDS_WELLBEINGEXPRESS,
  COLLECTION_DETAIL_PRODUCT_FIELDS_TUNE,
  COLLECTION_DETAIL_PRODUCT_FIELDS_YESEYESEE,
  COLLECTION_DETAIL_PRODUCT_FIELDS_THISISNEVERTHAT,
  COLLECTION_DETAIL_PRODUCT_FIELDS_KHAKIS,
  COLLECTION_DETAIL_PRODUCT_FIELDS_SUNLOVE,
  COLLECTION_DETAIL_PRODUCT_FIELDS_WELLBEINGEXPRESS,
  PRODUCT_DETAIL_FIELDS_TUNE,
  PRODUCT_RECOMMEND_FIELDS_TUNE,
  PRODUCT_DETAIL_FIELDS_YESEYESEE,
  PRODUCT_RECOMMEND_FIELDS_YESEYESEE,
  PRODUCT_DETAIL_FIELDS_THISISNEVERTHAT,
  PRODUCT_RECOMMEND_FIELDS_THISISNEVERTHAT,
  PRODUCT_DETAIL_FIELDS_KHAKIS,
  PRODUCT_RECOMMEND_FIELDS_KHAKIS,
  PRODUCT_DETAIL_FIELDS_SUNLOVE,
  PRODUCT_RECOMMEND_FIELDS_SUNLOVE,
  PRODUCT_DETAIL_FIELDS_WELLBEINGEXPRESS,
  PRODUCT_RECOMMEND_FIELDS_WELLBEINGEXPRESS,
  PREDICTIVE_SEARCH_PRODUCT_FIELDS_TUNE,
  PREDICTIVE_SEARCH_PRODUCT_FIELDS_YESEYESEE,
  PREDICTIVE_SEARCH_PRODUCT_FIELDS_THISISNEVERTHAT,
  PREDICTIVE_SEARCH_PRODUCT_FIELDS_KHAKIS,
  PREDICTIVE_SEARCH_PRODUCT_FIELDS_SUNLOVE,
  PREDICTIVE_SEARCH_PRODUCT_FIELDS_WELLBEINGEXPRESS,
  METAOBJECT_PRODUCT_REF_FIELDS_TUNE,
  METAOBJECT_PRODUCT_REF_FIELDS_YESEYESEE,
  METAOBJECT_PRODUCT_REF_FIELDS_THISISNEVERTHAT,
  METAOBJECT_PRODUCT_REF_FIELDS_WELLBEINGEXPRESS,
  PRODUCT_METAFIELDS_TENUI,
  COMMON_PRODUCT_FIELDS_TENUI,
  COMMON_COLLECTION_PRODUCT_FIELDS_TENUI,
  COLLECTION_DETAIL_PRODUCT_FIELDS_TENUI,
  PRODUCT_DETAIL_FIELDS_TENUI,
  PRODUCT_RECOMMEND_FIELDS_TENUI,
  PREDICTIVE_SEARCH_PRODUCT_FIELDS_TENUI,
  METAOBJECT_PRODUCT_REF_FIELDS_TENUI,
  COLLECTION_DETAIL_BASE_FIELDS,
];
